// The function below fires functions both on doc ready and window resize
(function() {
  function doubleLoad(){
    // Turns sidebar into collapsable menu on tablet & mobile
    if ($(window).width() < 980) {
      $('#sidebar').hide();
      
      var sidebarOpen = false;
      
      $('#sidebar_show').click(function(e){
        if(sidebarOpen == false) {
          $('#sidebar').slideDown(400);
          sidebarOpen = true;
        }
        
        else {
          $('#sidebar').slideUp(400);
          sidebarOpen = false;
        }
        
        // Cancel the default action
        e.preventDefault();
      });
    }
    
    else {
      $('#sidebar').show();
    }
    
    // This makes the dropdowns full width
//     $('.main-nav').on('mouseenter mousedown', '.tab_menu', function() {

//       // Get width of .nav container
//       var w = $('.main-nav').width();

//       // Add width due to padding if needed
//       w += 0;

//       $('.main-nav > li > .dropdown-menu').each(function() {
//         // Get relative offset of parent
//         var o = $(this).parents('.main_li').position().left;

//         // Add relative offset if padding or border on container
//         o += 0;

//         // Set styles for .dropdown-menu
//         $(this).css({
// //           width: w,
// //           left: -o // shift dropdown menu left (negative-sign)
//         });
//       });
//     });

    $('.supports-touch .has-menu').on('click', '.tab_menu', function(e) {
      e.preventDefault();
      if( $(this).hasClass("touched") ) {
		window.location = $(this).attr("href");
      } else {
        $(this).addClass("touched");
      }
    });
    

    // This make each menu into a toggle, but closes one if another is opened
    if ($(window).width() < 768) {
      // Hides menu initially.
      $('.dropdown-menu, .subLinkMenu').hide(); 

      $(".tab_menu").click(function(e) {
       
        $('.dropdown-menu').slideUp().removeClass('active-submenu');
        if( !$(this).hasClass("tab_active") ) {
          // Add class to the one we clicked.
          $(this).addClass("tab_active"); 
          $(this).delay(400).parent(".has-menu").find(".dropdown-menu").slideDown().addClass('active-submenu');
        } else {
          $(".tab_menu").removeClass("tab_active"); // Removes existing class.
        }
        e.preventDefault();
        e.stopImmediatePropagation();
      });

      // 	Sub mega menus
      $(".dropdown_header").click(function(e) {
        $('.subLinkMenu').slideUp().removeClass('dropdown_active');
        if( !$(this).parent('.subLinkHouse').find('.subLinkMenu').hasClass("dropdown_active") ) {
          // Add class to the one we clicked.
          $(this).delay(400).parent('.subLinkHouse').find(".subLinkMenu").slideDown().addClass('dropdown_active');
        } else {
          $(".subLinkMenu").removeClass("dropdown_active"); // Removes existing class.
        }
        e.preventDefault();
        e.stopImmediatePropagation();
      });



    };
  }

  $(window).on("resize", doubleLoad);
  $(document).on("ready", doubleLoad);
})();

$(document).ready(function() {
  
  // Target Mac/PC
  if (navigator.appVersion.indexOf("Mac")!=-1) {
    $('body').addClass('mac');
  } else {
    $('body').addClass('pc');
  }
  
  // Quantity values
  $('.up').click(function(e){
    e.preventDefault();
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[name='+fieldName+']').val());
    // If is not undefined
    if (!isNaN(currentVal)) {
      // Increment
      $('input[name='+fieldName+']').val(currentVal + 1);
    } else {
      // Otherwise put a 0 there
      $('input[name='+fieldName+']').val(1);
    }
  });
  
  $(".down").click(function(e) {
    e.preventDefault();
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[name='+fieldName+']').val());
    // If it isn't undefined or its greater than 0
    if (!isNaN(currentVal) && currentVal > 1) {
      // Decrement one
      $('input[name='+fieldName+']').val(currentVal - 1);
    } else {
      // Otherwise put a 0 there
      $('input[name='+fieldName+']').val(1);
    }
  });

  // Initialize Brands Carousel
  /*var owl = $("#brands_carousel"); 
  owl.owlCarousel({   
    itemsCustom : [
      [0, 3],
      [450, 3],
      [600, 4],
      [700, 5],
      [1000, 10],
      [1200, 10],
      [1400, 10],
      [1600, 10]
    ],
    lazyLoad : true,
    autoPlay : true,
    stopOnHover : true
  });*/

  // Initialize Product Owl Carousel
  var owl = $("#product_carousel"); 
  owl.owlCarousel({   
    itemsCustom : [
      [0, 1],
      [450, 2],
      [600, 2],
      [700, 3],
      [1000, 4],
      [1200, 4],
      [1400, 4],
      [1600, 4]
    ],
    lazyLoad : true,
    autoPlay : false,
    stopOnHover : true
  });

  // Custom Navigation Events
  $(".next").click(function(){
    owl.trigger('owl.next');
  })
  $(".prev").click(function(){
    owl.trigger('owl.prev');
  })

  // Call Fancybox globally on all elemnets with class "fancybox"
  $(".fancybox").fancybox({
    helpers: {
      overlay: {
        locked: false
      }
    }
  });

  // Product Image thumbnail change to main window
  $('.thumbs img').click( function() {
    $('#bigimage img').prop('src', $(this).prop('src'));
    return true;  //stop link from navigating
  })
  
    // Scroll to top button
  $(window).scroll(function(){
    if ($(this).scrollTop() > 100) {
      $('.scrollup').fadeIn();
    } else {
      $('.scrollup').fadeOut();
    }
  }); 
  
  $('.scrollup').click(function(){
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });
  
  // Add to cart from anywhere
  $('.add').on('click', addToCart);

});


// Manage Quick Cart + Add form wherever

function addToCart(e){
  
  if (typeof e !== 'undefined') e.preventDefault();
  
  var form      = $(this).parents('form');
  
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    async: false,
    data: form.serialize(),
    dataType: 'json',
    error: addToCartFail,
    success: addToCartSuccess,
    cache: false
  });
  
}

function addToCartSuccess (jqXHR, textStatus, errorThrown){
  
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    async: false,
    cache: false,
    dataType: 'json',
    success: updateCartDesc
  });
  $('.add-to-cart-msg').hide().addClass('success').html('Item added to cart! <a href="/cart" title="view cart">View cart and check out &raquo;</a>').fadeIn().delay(3000).fadeOut();
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  var response = $.parseJSON(jqXHR.responseText);
  $('.add-to-cart-msg').addClass('error').text(response.description).fadeIn().delay(3000).fadeOut();
}

function updateCartDesc(data){
  
  if ($(window).width() > 740) {
    $('#cartCount').text(data.item_count);
    
    $('#cartCost').text(side+((data.total_price)/100).toFixed(2));
    
    renderHoverCart(data);
  }
  else {
    $('#cartCount2').text( ' ' + data.item_count);
  }
}

function renderHoverCart(cart) {
  var source = $("#cartTemplate").html();
  var template = Handlebars.compile(source);
  var items = [];
  $.each(cart.items, function(i,o){
    items.push({
      id: o.id,
      title: o.title,
      url: o.url,
      price: Shopify.api.formatMoney(o.price),
      image: o.image.replace(/\.jpg/,"_small.jpg")
    });
  });
  $('#quick_cart').load('/ #quick_cart > *',function(){
    if(Currency.cookie.read()){
    Currency.convertAll(shopCurrency, Currency.cookie.read());
    }else{
    Currency.cookie.write(shopCurrency);
    };
  });
}

$(function(){
  $("#quick_cart").on('click', "a.remove_item", function(){
    console.log("removing item");
    var id = $(this).data("id");
    Shopify.api.changeItem(id,0, function(c){
      $('#cartCount').text(c.item_count);
      
      $('#cartCost').text(side+((c.total_price)/100).toFixed(2));
      
      if(!c.item_count) {
        $("#quick_cart").html("").hide();
      } else {
        renderHoverCart(c);
      }
    });
  });
});